import SliceNames from '@/state/enum';
import { ExposerActions, ExposerState } from '@/state/slices/exposer/typings';
import { IStore, SetState } from '@/state/slices/typings';

const exposerActionsCreator = (
	set: SetState<IStore>,
	get: () => IStore,
): ExposerActions => {
	return {
		[SliceNames.EXPOSER]: {
			setStore: (store: ExposerState[SliceNames.EXPOSER]['store']) => {
				set(
					(state) => ({
						...state,
						[SliceNames.EXPOSER]: {
							...state[SliceNames.EXPOSER],
							store,
						},
					}),
					undefined,
					{
						type: `${SliceNames.EXPOSER}/setStore`,
						store,
					},
				);
			},
			addComponents: (
				components: ExposerState[SliceNames.EXPOSER]['components'],
			) => {
				Object.keys(components).forEach((objKey) => {
					const existingComponent =
						get()[SliceNames.EXPOSER].components[objKey];
					const addingComponent = components[objKey];
					const areSameComponent =
						existingComponent === addingComponent;
					if (areSameComponent) {
						delete components[objKey];
					}
				});

				if (Object.keys(components).length > 0) {
					set(
						(state) => ({
							...state,
							[SliceNames.EXPOSER]: {
								...state[SliceNames.EXPOSER],
								components: {
									...state[SliceNames.EXPOSER].components,
									...components,
								},
							},
						}),
						undefined,
						{
							type: `${SliceNames.EXPOSER}/addComponents`,
							components,
						},
					);
				}
			},
		},
	};
};

export default exposerActionsCreator;
